import { render, staticRenderFns } from "./scoringAverage.vue?vue&type=template&id=79af3bb2&scoped=true&"
import script from "./scoringAverage.vue?vue&type=script&lang=js&"
export * from "./scoringAverage.vue?vue&type=script&lang=js&"
import style0 from "./scoringAverage.vue?vue&type=style&index=0&id=79af3bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af3bb2",
  null
  
)

export default component.exports